/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Click_Drag_Create_EventsInputs */



/**
* | output |
* | --- |
* | "Click-n-Drag to Create Events" |
*
* @param {Options_Editor_Click_Drag_Create_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_click_drag_create_events = /** @type {((inputs?: Options_Editor_Click_Drag_Create_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Click_Drag_Create_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cliquer-glisser pour créer des événements")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisse per Drag & Drop erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Fai clic e trascina per creare eventi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создание событий с помощью перетаскивания мышью.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Haga clic y arrastre para crear eventos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("点击并拖动即可创建事件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("クリック＆ドラッグでイベントを作成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट बनाने के लिए क्लिक करें और ड्रैग करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Clique e arraste para criar eventos")
	return /** @type {LocalizedString} */ ("Click-n-Drag to Create Events")
});